import { Permission } from '@Constants/Permission.g';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { getFrameLabel } from '@Constants/getFrameLabel';
import { useHasPermission } from '@Contexts/appContext';
import { ApiVehicleType } from '@Model';
import {
    Card,
    EditFrameMode,
    EditFrameShell,
    FrameEditBase,
    Grid,
    GridColumns,
    IFrameBodyProps,
    IFrameEditShellProps,
    TextInput,
    useFrameEditBaseNavigation,
    useGuiBinder,
    useTranslate,
} from '@synqo/frontend-component-library';
import { useParams } from 'react-router';

export function FrameEditVehicleType(props: IFrameEditShellProps<ApiVehicleType>) {
    const hasPermission = useHasPermission();
    const { itemId } = useParams();
    const primaryKey = props.primaryKey ?? itemId ?? '';

    const frameEditBaseNavigationEvents = useFrameEditBaseNavigation();

    return (
        <FrameEditBase<ApiVehicleType>
            apiResourcePath={`${STAMMDATEN_API}/vehicle_types`}
            renderer={FrameEditVehicleTypeBody}
            key={primaryKey}
            primaryKey={primaryKey}
            embedded={props.embedded || props.primaryKey !== undefined}
            canEdit={props.canEdit !== false && hasPermission(Permission.StammdatenVehicleTypeUpdate)}
            canCreate={props.canCreate !== false && hasPermission(Permission.StammdatenVehicleTypeCreate)}
            canDelete={props.canDelete !== false && hasPermission(Permission.StammdatenVehicleTypeDelete)}
            frameProps={{
                events: {
                    ...frameEditBaseNavigationEvents,
                    ...props.events,
                },
            }}
        />
    );
}

function FrameEditVehicleTypeBody(props: IFrameBodyProps<ApiVehicleType>) {
    const i18n = useTranslate('');

    const binder = useGuiBinder<ApiVehicleType>({
        ...props,
        canEdit: props.mode !== EditFrameMode.View,
    });

    return (
        <EditFrameShell
            headerProps={{
                label: getFrameLabel('Fahrzeug-Typ', props.mode),
                resourceLabel: 'Fahrzeug-Typ',
                ...props.events,
            }}
            bannerProps={{
                mode: props.mode,
                loading: props.stateQueueDepth > 0,
                ...props.events,
            }}
        >
            <Card name="VehicleTypeData" border={'withoutBorder'}>
                <Grid>
                    <GridColumns spans={[6, 6, 12]}>
                        <TextInput {...binder.bindToProp<string>('label')} label={i18n('Bezeichnung')} />
                        <TextInput {...binder.bindToProp<string>('shorthand')} label={i18n('Suchcode')} />
                        <TextInput {...binder.bindToProp<string>('remarks')} label={i18n('Bemerkung')} inputSize={5} />
                    </GridColumns>
                </Grid>
            </Card>
        </EditFrameShell>
    );
}
